import {Request} from 'Core/Common/Request';
import {P} from 'Core/Common/Promise';
import {Deserialize} from 'libs/cerialize';
import {AIQueryPropertyDto} from 'Core/GeneralProperties/Managers/AIQueryProperty/Stores/Models/AIQueryPropertyDto';

export class AIQueryStore {
    static GetAIQueries() {
        const deferred = P.defer<AIQueryPropertyDto[]>();

        Request.Send({
            proxy: {
                url: '/api/FormDesignerApi/GetAIQueries',
                type: 'GET'
            }
        })
            .then(exampleAppointments => {
                deferred.resolve(Deserialize(exampleAppointments, AIQueryPropertyDto))});

        return deferred.promise();
    }
}